import React, { useEffect, useState } from 'react';
import { locales } from '../../../../translations/locales';
import { _$, _addClass, _removeClass } from '../../../../controllers/dom';
import { NotificationManager } from 'react-notifications';
import NewSkill from './NewSkill';
import Loading from '../../../Loading';

const newFunctionSkills = [];

const ManageFunction = (props) => {
    const { locale, theme, data, ModuleRP } = props;
    const listSkills = data.skills;
    const listFunctions = data.functions;
    const [update, setUpdate] = useState(new Date());
    const [isLoad, setIsLoad] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const sortData = () => {
        listFunctions.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });
        listSkills.sort((a, b) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        });
    };
    sortData();
    if (!isLoad && data.type === 'function') {
        newFunctionSkills.length = 0;
        for (let i = 0; i < data.function.skills.length; i++) {
            const skill = data.function.skills[i];
            newFunctionSkills.push({
                skill: skill.skill,
                required: skill.required,
            });
        }
        setIsLoad(true);
        setUpdate(new Date());
    }

    const addSkill = () => {
        if (!_$('skillsList').value) {
            _addClass('skillsList', ['border', 'border-danger']);
            return NotificationManager.error(locales[locale].notifications.newGameNameInvalid);
        }
        let nbSKill = 1;
        for (let i = 0; i < newFunctionSkills.length; i++) {
            const skill = newFunctionSkills[i];
            if (skill.skill.split('_#')[0] === _$('skillsList').value) {
                nbSKill++;
            }
        }
        newFunctionSkills.push({
            skill: _$('skillsList').value + `${nbSKill > 1 ? '_#' + nbSKill : ''}`,
            required: true,
        });
        setUpdate(new Date());
    };
    const deleteSkillFunction = (deletedSKill) => {
        for (let i = 0; i < newFunctionSkills.length; i++) {
            const skill = newFunctionSkills[i];
            if (deletedSKill === skill.skill) {
                newFunctionSkills.splice(i, 1);
                return setUpdate(new Date());
            }
        }
    };
    const updateSkillFunction = (updatedSkill) => {
        for (let i = 0; i < newFunctionSkills.length; i++) {
            const skill = newFunctionSkills[i];
            if (updatedSkill.skill === skill.skill) {
                switch (skill.required) {
                    case true:
                        skill.required = false;
                        break;
                    case false:
                        skill.required = true;
                        break;
                }
                return setUpdate(new Date());
            }
        }
    };
    const updateFunction = () => {
        if (!_$('functionName').value || newFunctionSkills.length === 0) {
            return NotificationManager.error(locales[locale].notifications.functionsInvalid);
        }
        const params = ['id', 'name', 'skills'];
        const values = [data.function.id, _$('functionName').value, newFunctionSkills];
        ModuleRP.config.updateFunction(params, values);
    };
    const addNewSkill = () => {
        _addClass('bloc-newFunction', 'hide');
        _removeClass('bloc-newSkill', 'hide');
    };

    useEffect(() => {
        sortData();
    }, [update]);

    return (
        data.type === 'function' ?
            <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
                <div className={`m-4 p-1 border border-${theme === 'DARK' ? 'light' : 'dark'}`} id='bloc-newFunction'>
                    <h5 className='text-center'>
                        {locales[locale].config.manageFunction}
                    </h5>
                    <form onSubmit={(event) => {
                        event.preventDefault();
                        updateFunction();
                    }}>
                        <div className='form-group'>
                            <label htmlFor='functionName'>
                                {locales[locale].config.functionName}
                            </label>
                            <input
                                type='text'
                                id='functionName'
                                className='form-control'
                                placeholder={locales[locale].config.functionName}
                                defaultValue={data.function.name}
                            />
                        </div>
                    </form>
                    <form>
                        <div className='form-group'>
                            <div className='row'>
                                <div className='col'>
                                    <label htmlFor='skillsList'>
                                        {locales[locale].config.skills}
                                    </label>
                                    <button type='button'
                                        className={`btn btn-sm btn-${theme === 'DARK' ? 'light' : 'dark'} float-right`}
                                        onClick={addNewSkill}
                                    >
                                        {locales[locale].config.create} {locales[locale].config.skill}
                                    </button>
                                    <select className='form-control mt-1' id='skillsList'>
                                        {
                                            listSkills.map((skill) => (
                                                <option key={`listSkills_${skill.id || skill}`} value={skill.name || skill}>
                                                    {skill.name || skill}
                                                </option>
                                            ))
                                        }
                                        {
                                            listSkills.length === 0 &&
                                            <option value=''>
                                                Aucune compétence
                                            </option>
                                        }
                                    </select>
                                    <button type='button' className='btn btn-sm btn-primary float-right mt-1' onClick={addSkill}>
                                        {locales[locale].config.add} {locales[locale].config.skill}
                                    </button>
                                </div>
                                <div className='col border border-light rounded p-1 mr-3'>
                                    <h6 className='font-weight-bold'>
                                        {locales[locale].config.vehicleModelSkillsList}
                                    </h6>
                                    <table className={`table table-hover table-${theme === 'DARK' ? 'dark' : 'light'}`}>
                                        <thead>
                                            <tr>
                                                <th>{locales[locale].config.skill}</th>
                                                <th>{locales[locale].config.required}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                newFunctionSkills.map((skill) => (
                                                    <tr key={`newFunctionSkills_${skill.skill}`}>
                                                        <td>
                                                            {skill.skill.split('_#')[0]}

                                                        </td>
                                                        <td>
                                                            <div className="form-check">
                                                                <input
                                                                    type='checkbox'
                                                                    className='form-check-input'
                                                                    id={`check-${skill.skill}`}
                                                                    checked={skill.required ? true : false}
                                                                    onChange={() => updateSkillFunction(skill)}
                                                                />
                                                                <label className="form-check-label" htmlFor={`check-${skill.skill}`}></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <button
                                                                type='button'
                                                                className='btn btn-sm btn-danger'
                                                                onClick={() => deleteSkillFunction(skill.skill)}
                                                            >
                                                                x
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                            {
                                                newFunctionSkills.length === 0 &&
                                                <tr>
                                                    <td colSpan={3}>
                                                        Aucune compétence ajoutée
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </form>
                    {
                        newFunctionSkills.length > 0 &&
                        <div className='text-center'>
                            <button type='button' className='btn btn-primary' id='btn-confirm-update-function' onClick={updateFunction}>
                                {locales[locale].config.update}
                            </button>
                        </div>
                    }
                </div>
                <NewSkill
                    locale={locale}
                    theme={theme}
                    listSkills={listSkills}
                    newFunctionSkills={newFunctionSkills}
                    setUpdate={setUpdate}
                    ModuleRP={ModuleRP}
                />
                <div className="card container p-0 gameInformations mt-5 mb-2">
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <div className="row">
                            <div className="col-sm-8"></div>
                            <div className='col h-25 btn btn-danger' onClick={() => setConfirmDelete(true)}>
                                {locales[locale].config.deleteFunction}
                            </div>
                        </div>
                        <div className={confirmDelete ? '' : 'hide'} id="deleteFunction">
                            <hr className={`m-1 bg-secondary`} />
                            <div>
                                {locales[locale].config.deleteConfirmFunction}
                            </div>
                            <div className="text-center">
                                <button className='btn btn-sm btn-secondary w-25 m-3' onClick={() => setConfirmDelete(false)}>
                                    {locales[locale].no}
                                </button>
                                <button
                                    className='btn btn-sm btn-danger w-25 m-3'
                                    id='btn-delete-function'
                                    onClick={() => {
                                        ModuleRP.config.deleteFunction(data.function.id);
                                    }}
                                >
                                    {locales[locale].yes}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> :
            <Loading theme={theme} />
    );
};

export default ManageFunction;
